<template>
    <div>
        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Sla par catégorie et par période</h5>
                </div>
                <vs-row>
                    <div class="flex -mx-2">
                        <div class="w-2/4 px-2">
                            <span class="vs-select--label">Période</span>
                            <date-range-picker
                                ref="picker"
                                :opens="opens"
                                :locale-data=locale
                                :singleDatePicker="false"
                                :timePicker=false
                                :showWeekNumbers="showWeekNumbers"
                                :showDropdowns="showDropdowns"
                                :autoApply="autoApply"
                                v-model="dateRange"
                                :ranges=false
                                @update="updateValues"
                                :linkedCalendars="linkedCalendars"
                                :dateFormat="dateFormat"
                                :always-show-calendars="false"
                                :alwaysShowCalendars="alwaysShowCalendars"
                                class="vs-inputx vs-input--input"
                            >
                                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </div>
                            </date-range-picker>
                        </div>
                        <div class="w-3/4 px-2">
                            <span>Liste des catégories</span>
                            <v-select v-model="category" class="w-full" label="name"
                                placeholder="Sélectionner la catégorie"
                                :reduce="cat => cat.id"
                                :options="categories">
                            </v-select>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="canal === '' || dateRange.startDate === '' || dateRange.endDate === '' || category === ''" @click="makeSearch()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Exporter
                            </vs-button>
                        </div>
                    </div>
                </vs-row>
            </vs-card>
        </div>
    </div>
    
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import axios from "axios";
export default {
    name : "totalRequest",
    components: {DateRangePicker},
    data: () => ({
        category: '',
        categories: [],
        opens: 'right',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },
        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            if (!classes.disabled) {
            }
        return classes
        },
    }),
    mounted(){
        this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
        this.getCategory()
    },
    methods:{
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },

        getCategory(){
            this.$vs.loading()
            this.$http.get('/categories-requests?paginate=0').then((response) => {
                this.categories = response.data
                this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },
        
        makeSearch() {
            this.$vs.loading()
            axios({
            url: '/cex/request-sla-categories-period',
            method: 'POST',
            data: {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                category: this.category
            },
            responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'sla_par_categories_et_par_periode.xlsx')
                document.body.appendChild(link)
                link.click()
                this.category = ''
                this.$vs.loading.close()
            }).catch((error) => {
                this.error_base = error.response.data.errors
                this.$vs.loading.close()
                if (error.response.status === 401) {
                    this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                    })
                    this.$router.push({name: "login"})
                }
            })
        },
    }
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>